"use client";

import { SparklesIcon } from "@heroicons/react/24/solid";

import { useAuth } from "@/features/auth/shared/hooks/use-auth";
import { useLang } from "@/hooks/use-lang";

import { ChargeDuration } from "../../data/duration";

type Props = {
  duration: ChargeDuration;
  planNameText?: string;
};

export const CurrentPlanChip = ({ planNameText = "", duration }: Props) => {
  const { profile, isAuthenticated } = useAuth();
  const { t } = useLang();
  if (!isAuthenticated) return null;

  const plan = profile?.plan;
  const cardPlan = getCardPlan({ planNameText, duration });

  if (!cardPlan || !plan) return null;

  return plan.toLowerCase() === cardPlan ? (
    <div className="absolute -top-1 right-0 flex items-center gap-1 rounded-full bg-gradient-to-r from-[#FACC15] to-[#F97316] px-3 py-1 font-semibold text-white">
      <SparklesIcon className="h-5 w-5 text-white" />
      <p>{t.pricing.currentPlan}</p>
    </div>
  ) : null;
};

const getCardPlan = ({
  planNameText,
  duration,
}: {
  planNameText: string;
  duration: ChargeDuration;
}) => {
  if (new RegExp(/Free|免費/i).test(planNameText)) return `free`;
  if (new RegExp(/Beginning|入門/i).test(planNameText))
    return `beginning ${duration}`;
  if (new RegExp(/Basic|基本/i).test(planNameText)) return `basic ${duration}`;
  if (new RegExp(/Premium|進階/i).test(planNameText))
    return `premium ${duration}`;
  return "";
};
